<div fxFlex="column" class="confirm-dialog">

  <div class="dialog-header">
    Confirmation - {{ confirmTitle }}
  </div>

  <div class="dialog-container" fxLayout="column">

    <div class="dialog-text">
      {{ confirmText }}?
    </div>

    <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
      <div>
        <button class="button" [ngClass]="cancelBtn ? 'stay' : 'cancel '" mat-button type="button" (click)="onCancel()">
          {{ cancelBtn || 'Cancel' }}
        </button>
      </div>
      <div>
        <button class="submit button" mat-button type="button" (click)="onConfirm()">
          {{ confirmBtn || 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</div>
